import { WidgetProps } from '@rjsf/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { themes as commonThemes } from '@sitebuilder/common';
import { StateShape as ReduxStateShape } from '../../reducers';

const TypographyClassSelect = (props: WidgetProps) => {
    const { label, value, onChange } = props;

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        e.preventDefault();
        onChange(e.target?.value);
    };

    let typographyOptions: any = Object.keys(commonThemes.defaultTypography).map((key: any) => ({
        id: `theme-typography${key}`,
    }));

    const { theme } = useSelector((state: ReduxStateShape) => ({
        ...state?.themes,
    }));

    if (theme) {
        typographyOptions = [
            ...Object.keys({
                ...commonThemes.defaultTypography,
                ...theme?.typography,
                ...theme?.userTypography,
            }).map((key: any) => ({
                id: `theme-typography${key}`,
            })),
        ];
    }

    return (
        <div className="custom-select">
            <label className="select-label">{label}</label>
            <select
                className="custom-select-input"
                data-testid="select"
                onChange={handleChange}
                defaultValue={value}
            >
                {[{ id: '' }, ...typographyOptions].map((key: any, i: number) => (
                    <option
                        data-testid="select-option"
                        key={`${key.id}-${i}`}
                        id={key.id}
                        value={key.id}
                    >
                        {key.id}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default TypographyClassSelect;
